import { cx } from "@emotion/css";
import { Outlet, useLocation } from "react-router-dom";

import { isWhiteRootLayoutPath } from "@/app.constant";
import { ScrollToTop } from "@/components";

export function RootLayout() {
  const { pathname } = useLocation();
  const whiteRootLayout = isWhiteRootLayoutPath(pathname);

  return (
    <div
      className={cx(
        "relative flex min-h-screen flex-col",
        whiteRootLayout ? "bg-white" : "bg-[#F6F6F6]"
      )}
    >
      <ScrollToTop />
      <Outlet />
    </div>
  );
}
